class ActivityStatus {}

ActivityStatus.PENDING = 0
ActivityStatus.SUCCESS = 1
ActivityStatus.FAILED = 2
ActivityStatus.DISMISSED = 3

export default ActivityStatus
